<script lang="ts">
  import type { Distributor } from "@shared/types/Distributor";
  import type { PLDistributor } from "@shared/types/ProductLine";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";

  export let salesReps = [];
  export let distributor: Distributor | PLDistributor | null;

  $: noSalesRepsNeeded = distributor && distributor.no_sales_reps_needed;
  let repText: string;
  $: repText = !noSalesRepsNeeded ? "Sales rep" + (salesReps.length == 1 ? "" : "s") : "Sales rep";

</script>

{#if salesReps.length != 0 || noSalesRepsNeeded}
  <div class="fizz-flex-row-inline" id="assigned-reps-section" data-testid="assigned-reps-section">
    <strong class="fizz-nowrap fizz-text-medium">
      {repText + ": "}
      {#if salesReps.length == 0 && noSalesRepsNeeded}
        {distributor.name} Sales
      {:else}
        <UIRouterLink stateName="layout.accounts">
          <span class="fizz-flex-row-inline">
            <span class="fizz-truncate fizz-inline-4">{salesReps[0].name}</span>
            <span class="fizz-nowrap"
              >{#if salesReps.length > 1},+{salesReps.length - 1} more{/if}</span
            >
          </span>
        </UIRouterLink>
      {/if}
    </strong>
  </div>
{/if}
